module.exports = __webpack_public_path__ + "static/media/YM45_2.3266a5ce.jpg";